import * as React from "react";

import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { TICKET_PRIORITY_LABEL_MAP } from "constants/tickets/priorities";
import { TicketPriority } from "interfaces/entities/ticket";

import PriorityIndicator from "./PriorityIndicator";

interface IProps {
  priority: TicketPriority;
}

const PrioritySelectItem: React.FC<IProps> = ({ priority }) => (
  <Flex alignItems="center">
    <Block minWidth="20px" minHeight="20px">
      <PriorityIndicator priority={priority} />
    </Block>{" "}
    <p id={`${TICKET_PRIORITY_LABEL_MAP[priority].toLowerCase()}`}>{TICKET_PRIORITY_LABEL_MAP[priority]}</p>
  </Flex>
);

export default PrioritySelectItem;
